import { clients } from "../../../lib/https";
import { ConfigurationSettings } from "/models/configuration-settings";
import { 
    CreateCustomGptRequest, 
    CustomGpt, 
    CustomGptFile, 
    CustomGptFilesResponse,
    CustomGptListResponse,
    UpdateCustomGptRequest
} from "../types/custom-gpt.types";

export const createCustomGpt = async (
    config: ConfigurationSettings, 
    payload: CreateCustomGptRequest
): Promise<CustomGpt> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}`;
    return clients.post<CustomGpt>(url, config.blocksKey, JSON.stringify(payload));
};

export const listCustomGpts = async (
    config: ConfigurationSettings
): Promise<CustomGptListResponse> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}`;
    return clients.get<CustomGptListResponse>(url, config.blocksKey);
};

export const getCustomGpt = async (
    config: ConfigurationSettings,
    customGptId: string
): Promise<CustomGpt> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}/${customGptId}`;
    return clients.get<CustomGpt>(url, config.blocksKey);
};

export const updateCustomGpt = async (
    config: ConfigurationSettings,
    customGptId: string,
    payload: UpdateCustomGptRequest
): Promise<CustomGpt> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}/${customGptId}`;
    return clients.put<CustomGpt>(url, config.blocksKey, JSON.stringify(payload));
};

export const listFilesForCustomGpt = async (
    config: ConfigurationSettings,
    customGptId: string
): Promise<CustomGptFile[]> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}/${customGptId}/files`;
    const response = await clients.get<CustomGptFilesResponse>(url, config.blocksKey);
    return response.data;
};

export const uploadFileToCustomGpt = async (
    config: ConfigurationSettings,
    customGptId: string,
    file: File
): Promise<CustomGptFile> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}/${customGptId}/files`;
    
    const formData = new FormData();
    formData.append('file', file);
    
    return clients.post<CustomGptFile>(url, config.blocksKey, formData, {}, true);
};


export const deleteCustomGptFile = async (
    config: ConfigurationSettings,
    customGptId: string,
    fileId: string
): Promise<void> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}/${customGptId}/files/${fileId}`;
    return clients.delete(url, config.blocksKey);
};

export const deleteCustomGpt = async (
    config: ConfigurationSettings,
    customGptId: string
): Promise<void> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.customGpts}/${customGptId}`;
    return clients.delete(url, config.blocksKey);
};
